import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddMany = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 23 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_2208",
		"data-name": "Group 2208",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_803",
				"data-name": "Path 803",
				d: "M4.951,4.952a9.5,9.5,0,1,1,13.1,13.1",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_543",
				"data-name": "Ellipse 543",
				cx: 9.5,
				cy: 9.5,
				r: 9.5,
				transform: "translate(0.5 3.5)",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_405",
				"data-name": "Line 405",
				x2: 12,
				transform: "translate(4.321 12.679)",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_406",
				"data-name": "Line 406",
				y2: 12,
				transform: "translate(10.321 6.679)",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 1
			})
		]
	})
});
export default SvgAddMany;
